<template>
  <div class="DeviceInfo-page" ref="container">
		<div class="info-top">
			<div class="top-icon"></div>
			<div class="top-content">
				<div class="top-one">{{deviceInfo.snCode}}</div>
				<div class="top-two">{{deviceInfo.gpsAddress}}</div>
			</div>
		</div>
		<div class="info-content">
			<div class="info-box">
				<div class="info-box-title">
					基础信息
					<div class="edit-icon" @click="deviceConfig"></div>
				</div>
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">所属人</div>
						<div class="label-value">{{deviceInfo.realName}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">名称</div>
						<div class="label-value">{{deviceInfo.name || '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">地址</div>
						<div class="label-value">{{deviceInfo.address || '-'}}{{deviceInfo.detailed_address || '-'}}</div>
					</div>
				</div>
			</div>
			<div class="info-box">
				<div class="info-box-title">
					设备状态
				</div>
				<div class="info-box-tips " :class="deviceInfo.isOut ? 'outline' : 'online'">{{deviceInfo.statusStr}}</div>
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">水温</div>
						<div class="label-value">{{deviceInfo.watertemp && !deviceInfo.isOut ? deviceInfo.watertemp : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">室温</div>
						<div class="label-value">{{deviceInfo.roomtemp && !deviceInfo.isOut ? deviceInfo.roomtemp : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">开门状态</div>
						<div class="label-value">{{!deviceInfo.isOut ? (deviceInfo.door ? '开启' : '关闭') : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">运行状态</div>
						<div class="label-value">{{!deviceInfo.isOut ? (deviceInfo.estop ? '开启' : '紧急停止中') : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">水位</div>
						<div class="label-value">{{!deviceInfo.isOut ? (deviceInfo.watertank ? '正常' : '水位异常') : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">网络</div>
						<div class="label-value">{{!deviceInfo.isOut ? (deviceInfo.network ? '正常' : '网络异常') : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">最后在线时间</div>
						<div class="label-value">{{deviceInfo.lastStatusTime}}</div>
					</div>
				</div>
			</div>
			<div class="info-box">
				<div class="info-box-title">当前费用<div class="edit-icon" @click="priceConfig" v-if="deviceInfo.is_own"></div></div>
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">类型</div>
						<div class="label-value">默认</div>
						<div class="label-value">当前</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗烘(大)</div>
						<div class="label-value">{{deviceInfo.allPrice}}</div>
						<div class="label-value ">{{deviceInfo.allPriceS}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗烘(小)</div>
						<div class="label-value">{{deviceInfo.mini_allPrice}}</div>
						<div class="label-value">{{deviceInfo.mini_allPriceS}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">仅烘干(大)</div>
						<div class="label-value">{{deviceInfo.onlyPrice}}</div>
						<div class="label-value">{{deviceInfo.onlyPriceS}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">仅烘干(小)</div>
						<div class="label-value">{{deviceInfo.mini_onlyPrice}}</div>
						<div class="label-value">{{deviceInfo.mini_onlyPriceS}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">烘干单价(元/分钟)</div>
						<div class="label-value">{{deviceInfo.dry_unit_price}}</div>
						<div class="label-value">{{deviceInfo.dry_unit_priceS}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗护单价(元/分钟)</div>
						<div class="label-value">{{deviceInfo.wash_unit_price}}</div>
						<div class="label-value">{{deviceInfo.wash_unit_priceS}}</div>
					</div>
				</div>
			</div>
			
			<div class="info-box">
				<div class="info-box-title">温度配置<div class="edit-icon" @click="temperatureConfig" v-if="deviceInfo.is_own"></div></div>
				<div class="info-box-content">
					<div class="info-box-label">
						<div class="label-name">类型</div>
						<div class="label-value">最高</div>
						<div class="label-value">最低</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">待机水温</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.standbyWater.max + "℃" : "--"}}</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.standbyWater.min + "℃" : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">洗烘水温</div>
						<div class="label-value">{{deviceInfo.temperature ? deviceInfo.temperature.washWater.max + "℃" : '--'}}</div>
						<div class="label-value">{{deviceInfo.temperature ? deviceInfo.temperature.washWater.min + "℃" : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">待机室温</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.standbySpace.max + "℃" : '--'}}</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.standbySpace.min + "℃" : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">烘干室温</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.drySpace.max + "℃" : '--'}}</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.drySpace.min + "℃" : '--'}}</div>
					</div>
					<div class="info-box-label">
						<div class="label-name">烘干室温(剩{{deviceInfo.temperature  ?  deviceInfo.temperature.drySpacelast.mins : '--'}}分钟)</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.drySpacelast.max + "℃" : '--'}}</div>
						<div class="label-value">{{deviceInfo.temperature  ?  deviceInfo.temperature.drySpacelast.min + "℃" : '--'}}</div>
					</div>
				</div>
			</div>
			
		</div>
  
		<div class="btn-view" v-if="deviceInfo.is_own">
			<div class="btn" @click="doSth('startdis')">消毒</div>
			<div class="btn" @click="doSth('startwater')">冲洗</div>
			<div class="btn solid" @click="doSth('estop')">紧急停止</div>
		</div>
	</div>
</template>
<script>
import PetApi from "../../api/petAdmin";
export default {
  name: "PetAdminDeviceInfo",
  components: {},
  props: {},
  data: function() {
    return {
			deviceSn: this.$route.params.deviceSn,
			deviceInfo : {}
    };
  },
  watch: {
    "$route.params.deviceSn": function(newVal) {
      var that = this;
      if (newVal != undefined && newVal != that.deviceSn) {
				that.deviceSn = newVal;
				that.getInfo()
      }
    }
  },
  mounted: function() {
		this.getInfo()
  },
  computed: {},
  methods: {
		doSth(type) 
		{
			let that = this;
			let typeStr = '';
			switch (type){
				case 'startdis':
					typeStr = "消毒";
					break;
				case 'startwater':
					typeStr = "冲洗";
					break;
				default:
					typeStr = "停止";
					break;
			}
			this.$dialog.confirm({
			  mes: "您确认" + typeStr + "工作吗?",
			  opts: () => {
					PetApi.petDeviceDoSth({
						deviceSn : that.deviceInfo.snCode,
						type : type
					}).then(
						res => {
							that.$dialog.message(res.msg);
						},
						error => {
						  that.$dialog.message(error.msg);
						}
					)
			  }
			});
		},
		search(filter) {
			this.$refs.list.reload(filter);
		},
		reload() {
			
		},
		temperatureConfig() {
			this.$router.push({ path: "/petAdmin/temperatureConfig/" + this.deviceInfo.snCode });
		},
		priceConfig() {
			this.$router.push({ path: "/petAdmin/priceConfig/" + this.deviceInfo.snCode });
		},
		deviceConfig() {
			this.$router.push({ path: "/petAdmin/deviceConfig/" + this.deviceInfo.snCode });
		},
		getInfo() {
			let that = this;
			PetApi.petDeviceInfo(that.deviceSn).then(
			  res => {
					that.deviceInfo = res.data;
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {}
.DeviceInfo-page {
	.info-top {
		background-color: #fff;
		padding: 0.36rem 0.52rem;
		display: flex;
		align-items: center;
		
		.top-icon {
			width: .76rem;
			height: .76rem;
			background-size: 100%;
			background-image:url('data:image/png;base64,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');
		}
	
		.top-content {
			margin-left: 0.2rem;
			.top-one {
				font-weight: bold;
				font-size: .34rem;
				color: #000000;
			}
			.top-two {
				font-weight: 400;
				font-size: .28rem;
				color: #999999;
				width: 5.5rem;
			}
		}
	
	}
	
	.info-content {
		padding: 0 0.32rem;
		.info-box {
			background: #FFFFFF;
			border-radius: .20rem;
			margin-top: 0.24rem;
			padding: 0.2rem;
			position: relative;
			
			.info-box-title {
				font-weight: bold;
				font-size: .32rem;
				color: #000000;
				display: flex;
				align-items: center;
				justify-content: space-between;
				
				&.mt {
					margin-top: 0.24rem;
				}
				
				.edit-icon {
					width: .40rem;
					height: .38rem;
					background-size: 100%;
					background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAIAAAA5lk5KAAACW0lEQVRYhb3Yz2sTQRQH8PfeTjYxLUahDY0asD3EH0c91NYipIjak2cVpHgRBOvFv6CnQrE3L4LYqz8wvYhIBYWQHqwHBQ1IQ2kDKqWCNEljmpnd8bDbjcYf2e3M9nt6O7PsZ3ZmdmEXpZTgxKqL4owo52S1JJsVUA5SxOi/ZJ6eBcC/9Dqwvb7QLIzblSV1ry2xC3lKjvzZzhx168UZaVvaVWR7sPtw61haonhHVpfZsVsMrHqzMO6p1JWmvizGD2pgyWTpixg/5KnN/GWx8ggArLVXTBRnvBlmA1fMoXtgxDWobflFBQAQdRLlnDu+rvTuqGhEzeH7JKslF+7L7o4azeYodY68J0fPuvpRD4wBAOnHfKhhwv9VQ4M7qeHAPtQQYH+qbti3qhXupNrrBVlb1g13UvniROP5SGPuqL32Wh/sY4bFykMAkDa3yk81wT7X1eZthRocZDe1RQFWUBVgNXWnsLK6I1iHGhzWpAaE9anBYL44oUsNBovVJ7rUYDAbuAoAaO6NZucUVXC+JHwmcnKaHbmB0f0Q2aeoBoMBALv71UknhLg92957PIx4F0fDhSGWdLs2iiGhcrMsec11tzkyek+58Jd5+f1dGLD4OO3V1DPoFixz3R2XzRsvx6zVxyBquki5WeZvbopPd10skaHUqFOjlLK5cE2UHnhnIxKYCQ2szb0ZBgAkI3o+T71DLRj4xtb8WevbWw3YP4JkRE5MseO3Wy3uPxApxIcp/n5ShrC3KZExh2e9e/0ddvLjq/X5mV1ZAq7h5wuggbEk9QxSahQw0tb5E0FzeeLqyAO4AAAAAElFTkSuQmCC');
				}
			}
			.info-box-tips {
				position: absolute;
				top: 0;
				right: 0;
				
				color: #fff;
				font-weight: 400;
				font-size: 0.22rem;
				padding: 0.02rem 0.16rem;
				border-top-right-radius: 0.2rem;
				border-bottom-left-radius: 0.2rem;
				
				&.outline {
					background: #F7301D;
				}
				&.online {
					background: #3DC60C;
				}
			}
			.info-box-content {
				.info-box-label {
					margin-top: 0.24rem;
					display: flex;
					justify-content: space-between;
					
					.label-name {
						font-weight: 400;
						font-size: .30rem;
						color: #666666;
						width: 2.7rem;
					}
					.label-value {
						font-weight: 400;
						font-size: .30rem;
						color: #333333;
						text-align: right;
						flex: 1;
					}
				}
			}
		}
	}

	.btn-view {
		margin-top: 0.4rem;
		margin-bottom: 0.4rem;
		padding: 0 0.32rem;
		display: flex;
		justify-content: space-between;
		
		.btn {
			width: 2rem;
			text-align: center;
			line-height: 1rem;
			font-size: .34rem;
			height: 1rem;
			color: #F5A100;
			border-radius: .5rem;
			border: 0.02rem solid #F5A100;
			
			&.solid {
				background: #F5A100;
				color: #FFFFFF;
			}
		}
	}
}

</style>
